export interface ForumCategory {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
  color: string;
}

export interface ForumArticle {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  publishDate: string;
  viewCount: number;
  commentCount: number;
  tags: string[];
  thumbnail: string;
}

export const forumCategories: ForumCategory[] = [
  {
    slug: 'zonghe-jiaoliu',
    name: '综合交流',
    description: '论坛综合讨论区，涵盖各类热门话题交流、会员互动与日常分享',
    icon: 'ri-chat-3-line',
    articleCount: 1286,
    color: 'primary',
  },
  {
    slug: 'jishu-taolun',
    name: '技术讨论',
    description: '网络技术、安全防护、工具软件等技术类话题的深度交流与学习',
    icon: 'ri-code-s-slash-line',
    articleCount: 943,
    color: 'accent',
  },
  {
    slug: 'ziyuan-fenxiang',
    name: '资源分享',
    description: '优质资源分享平台，包含各类数字资源的交流与推荐',
    icon: 'ri-folder-shared-line',
    articleCount: 2157,
    color: 'primary',
  },
  {
    slug: 'xinren-zhuanqu',
    name: '新人专区',
    description: '新手引导、注册教程、使用帮助与常见问题解答',
    icon: 'ri-user-smile-line',
    articleCount: 532,
    color: 'secondary',
  },
  {
    slug: 'xiuxian-yule',
    name: '休闲娱乐',
    description: '轻松休闲话题，影视音乐文学等文化娱乐内容交流',
    icon: 'ri-movie-2-line',
    articleCount: 1674,
    color: 'accent',
  },
  {
    slug: 'shequ-gonggao',
    name: '社区公告',
    description: '论坛官方公告、规则更新、活动通知与重要信息发布',
    icon: 'ri-megaphone-line',
    articleCount: 189,
    color: 'secondary',
  },
];

export const featuredArticles: ForumArticle[] = [
  {
    id: '1',
    slug: 'caoliu-luntan-zuixin-rukou-dizhi-2026',
    title: '草榴论坛最新入口地址汇总（2026年8月更新）',
    excerpt: '本文整理了草榴论坛最新可用的入口地址与备用域名，确保您能够稳定访问论坛全部功能。包含主域名、备用域名及防屏蔽技巧。',
    content: '',
    category: 'xinren-zhuanqu',
    author: '论坛管理员',
    publishDate: '2026-08-01',
    viewCount: 38542,
    commentCount: 287,
    tags: ['入口地址', '域名', '访问教程'],
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20digital%20interface%20with%20warm%20amber%20and%20cream%20color%20scheme%2C%20abstract%20network%20connection%20nodes%2C%20clean%20tech%20aesthetic%2C%20soft%20gradient%20background%2C%20editorial%20design%20style%20with%20smooth%20curves%20and%20warm%20lighting&width=800&height=450&seq=article-thumb-01&orientation=landscape',
  },
  {
    id: '2',
    slug: 'caoliu-luntan-zhuce-jiaocheng-xiangjie',
    title: '草榴论坛注册登录完整教程（2026最新版）',
    excerpt: '手把手教你完成草榴论坛的注册与登录流程，包括邮箱验证、账号设置、安全配置等详细步骤说明。',
    content: '',
    category: 'xinren-zhuanqu',
    author: '新手引导员',
    publishDate: '2026-07-28',
    viewCount: 52310,
    commentCount: 416,
    tags: ['注册教程', '登录', '账号设置'],
    thumbnail: 'https://readdy.ai/api/search-image?query=Clean%20modern%20registration%20form%20interface%20with%20warm%20cream%20background%2C%20soft%20coral%20accents%2C%20minimalist%20UI%20design%2C%20user-friendly%20onboarding%20visual%2C%20warm%20ambient%20lighting%2C%20professional%20tech%20aesthetic&width=800&height=450&seq=article-thumb-02&orientation=landscape',
  },
  {
    id: '3',
    slug: 'caoliu-luntan-banxie-jieshao',
    title: '草榴论坛各版块详细介绍与使用指南',
    excerpt: '全面了解草榴论坛所有版块的功能定位、发帖规则与浏览技巧，帮助您快速融入社区。',
    content: '',
    category: 'zonghe-jiaoliu',
    author: '资深会员',
    publishDate: '2026-07-25',
    viewCount: 28976,
    commentCount: 195,
    tags: ['版块介绍', '使用指南', '社区规则'],
    thumbnail: 'https://readdy.ai/api/search-image?query=Organized%20digital%20content%20categories%20dashboard%20with%20warm%20amber%20highlights%2C%20clean%20grid%20layout%2C%20minimalist%20information%20architecture%2C%20cream%20background%20with%20soft%20shadows%2C%20editorial%20design&width=800&height=450&seq=article-thumb-03&orientation=landscape',
  },
  {
    id: '4',
    slug: 'caoliu-luntan-anquan-shiyong-zhinan',
    title: '草榴论坛安全使用与隐私保护指南',
    excerpt: '保护个人隐私与账号安全是使用论坛的首要前提。本文详细介绍安全浏览论坛的各类方法与注意事项。',
    content: '',
    category: 'jishu-taolun',
    author: '安全顾问',
    publishDate: '2026-07-20',
    viewCount: 41982,
    commentCount: 523,
    tags: ['安全指南', '隐私保护', '网络安全'],
    thumbnail: 'https://readdy.ai/api/search-image?query=Digital%20security%20shield%20concept%20with%20warm%20coral%20tone%2C%20abstract%20protection%20visualization%2C%20clean%20minimalist%20tech%20aesthetic%2C%20soft%20cream%20background%2C%20professional%20cybersecurity%20illustration%20style&width=800&height=450&seq=article-thumb-04&orientation=landscape',
  },
  {
    id: '5',
    slug: 'caoliu-luntan-gaoji-sousuo-jiqiao',
    title: '草榴论坛高级搜索技巧与内容发现方法',
    excerpt: '掌握论坛高级搜索功能，快速精准定位所需内容。包含关键词组合、标签筛选及时间范围搜索等技巧。',
    content: '',
    category: 'jishu-taolun',
    author: '技术达人',
    publishDate: '2026-07-15',
    viewCount: 16354,
    commentCount: 142,
    tags: ['搜索技巧', '内容发现', '高级功能'],
    thumbnail: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20digital%20data%20with%20warm%20amber%20glow%2C%20clean%20search%20interface%20concept%2C%20minimalist%20design%20with%20cream%20background%2C%20tech%20aesthetic%20with%20soft%20lighting&width=800&height=450&seq=article-thumb-05&orientation=landscape',
  },
  {
    id: '6',
    slug: 'caoliu-luntan-yidongduan-fangwen-jiaocheng',
    title: '草榴论坛移动端访问与APP使用教程',
    excerpt: '详细讲解如何在手机和平板设备上流畅访问草榴论坛，包括移动浏览器设置与专属客户端使用指南。',
    content: '',
    category: 'jishu-taolun',
    author: '移动端专家',
    publishDate: '2026-07-10',
    viewCount: 22671,
    commentCount: 308,
    tags: ['移动端', 'APP', '手机访问'],
    thumbnail: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20clean%20forum%20interface%20with%20warm%20coral%20and%20cream%20color%20scheme%2C%20mobile%20responsive%20design%2C%20minimalist%20UI%2C%20soft%20ambient%20lighting%2C%20modern%20tech%20lifestyle&width=800&height=450&seq=article-thumb-06&orientation=landscape',
  },
];

export const allArticles: Record<string, ForumArticle[]> = {
  'zonghe-jiaoliu': [
    {
      id: '3',
      slug: 'caoliu-luntan-banxie-jieshao',
      title: '草榴论坛各版块详细介绍与使用指南',
      excerpt: '全面了解草榴论坛所有版块的功能定位、发帖规则与浏览技巧，帮助您快速融入社区。',
      content: '',
      category: 'zonghe-jiaoliu',
      author: '资深会员',
      publishDate: '2026-07-25',
      viewCount: 28976,
      commentCount: 195,
      tags: ['版块介绍', '使用指南', '社区规则'],
      thumbnail: 'https://readdy.ai/api/search-image?query=Organized%20digital%20content%20categories%20dashboard%20with%20warm%20amber%20highlights%2C%20clean%20grid%20layout%2C%20minimalist%20information%20architecture%2C%20cream%20background%20with%20soft%20shadows&width=800&height=450&seq=article-cat-01&orientation=landscape',
    },
    {
      id: '7',
      slug: 'caoliu-luntan-shequ-wenhua-jiedu',
      title: '草榴论坛社区文化与交流礼仪指南',
      excerpt: '深入了解草榴论坛独特的社区文化、交流习惯与基本礼仪，帮助新会员快速获得良好社区体验。',
      content: '',
      category: 'zonghe-jiaoliu',
      author: '文化观察员',
      publishDate: '2026-07-05',
      viewCount: 12450,
      commentCount: 98,
      tags: ['社区文化', '交流礼仪', '新人指南'],
      thumbnail: 'https://readdy.ai/api/search-image?query=Community%20gathering%20abstract%20concept%20with%20warm%20amber%20and%20coral%20tones%2C%20connected%20people%20network%2C%20clean%20minimalist%20illustration%20style%2C%20cream%20background%2C%20friendly%20atmosphere&width=800&height=450&seq=article-cat-02&orientation=landscape',
    },
    {
      id: '8',
      slug: 'caoliu-luntan-rement-huati-jiaoliu',
      title: '草榴论坛热门话题讨论规范与参与指南',
      excerpt: '了解论坛热门话题的讨论规范，学习如何有效参与话题交流，提升社区互动质量。',
      content: '',
      category: 'zonghe-jiaoliu',
      author: '版主团队',
      publishDate: '2026-06-30',
      viewCount: 18320,
      commentCount: 234,
      tags: ['热门话题', '讨论规范', '社区互动'],
      thumbnail: 'https://readdy.ai/api/search-image?query=Discussion%20forum%20abstract%20visual%20with%20warm%20gradient%20tones%2C%20speech%20bubbles%20network%2C%20clean%20minimalist%20design%2C%20cream%20background%2C%20modern%20communication%20concept&width=800&height=450&seq=article-cat-03&orientation=landscape',
    },
  ],
  'jishu-taolun': [
    {
      id: '4',
      slug: 'caoliu-luntan-anquan-shiyong-zhinan',
      title: '草榴论坛安全使用与隐私保护指南',
      excerpt: '保护个人隐私与账号安全是使用论坛的首要前提。本文详细介绍安全浏览论坛的各类方法与注意事项。',
      content: '',
      category: 'jishu-taolun',
      author: '安全顾问',
      publishDate: '2026-07-20',
      viewCount: 41982,
      commentCount: 523,
      tags: ['安全指南', '隐私保护', '网络安全'],
      thumbnail: 'https://readdy.ai/api/search-image?query=Digital%20security%20shield%20concept%20with%20warm%20coral%20tone%2C%20abstract%20protection%20visualization%2C%20clean%20minimalist%20tech%20aesthetic%2C%20soft%20cream%20background&width=800&height=450&seq=article-cat-04&orientation=landscape',
    },
    {
      id: '5',
      slug: 'caoliu-luntan-gaoji-sousuo-jiqiao',
      title: '草榴论坛高级搜索技巧与内容发现方法',
      excerpt: '掌握论坛高级搜索功能，快速精准定位所需内容。包含关键词组合、标签筛选及时间范围搜索等技巧。',
      content: '',
      category: 'jishu-taolun',
      author: '技术达人',
      publishDate: '2026-07-15',
      viewCount: 16354,
      commentCount: 142,
      tags: ['搜索技巧', '内容发现', '高级功能'],
      thumbnail: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20digital%20data%20with%20warm%20amber%20glow%2C%20clean%20search%20interface%20concept%2C%20minimalist%20design%20with%20cream%20background&width=800&height=450&seq=article-cat-05&orientation=landscape',
    },
    {
      id: '6',
      slug: 'caoliu-luntan-yidongduan-fangwen-jiaocheng',
      title: '草榴论坛移动端访问与APP使用教程',
      excerpt: '详细讲解如何在手机和平板设备上流畅访问草榴论坛，包括移动浏览器设置与专属客户端使用指南。',
      content: '',
      category: 'jishu-taolun',
      author: '移动端专家',
      publishDate: '2026-07-10',
      viewCount: 22671,
      commentCount: 308,
      tags: ['移动端', 'APP', '手机访问'],
      thumbnail: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20clean%20forum%20interface%20with%20warm%20coral%20and%20cream%20color%20scheme%2C%20mobile%20responsive%20design%2C%20minimalist%20UI&width=800&height=450&seq=article-cat-06&orientation=landscape',
    },
  ],
  'ziyuan-fenxiang': [
    {
      id: '9',
      slug: 'caoliu-luntan-ziyuan-shangchuan-jiaocheng',
      title: '草榴论坛资源上传规范与教程',
      excerpt: '详细介绍论坛资源上传的规范要求、文件格式限制及最佳实践，确保资源分享高效合规。',
      content: '',
      category: 'ziyuan-fenxiang',
      author: '资源管理员',
      publishDate: '2026-07-08',
      viewCount: 14230,
      commentCount: 112,
      tags: ['资源上传', '规范教程', '文件分享'],
      thumbnail: 'https://readdy.ai/api/search-image?query=File%20sharing%20and%20upload%20concept%20with%20warm%20amber%20color%20scheme%2C%20cloud%20storage%20abstract%20visualization%2C%20clean%20minimalist%20design%2C%20cream%20background%2C%20modern%20tech%20illustration&width=800&height=450&seq=article-cat-07&orientation=landscape',
    },
    {
      id: '10',
      slug: 'caoliu-luntan-ziyuan-xiazai-zhuyi-shixiang',
      title: '草榴论坛资源下载注意事项与安全提示',
      excerpt: '下载论坛资源前的安全检查清单，包括文件扫描、来源验证与版权注意事项。',
      content: '',
      category: 'ziyuan-fenxiang',
      author: '安全管理员',
      publishDate: '2026-06-28',
      viewCount: 21560,
      commentCount: 167,
      tags: ['资源下载', '安全提示', '版权注意'],
      thumbnail: 'https://readdy.ai/api/search-image?query=Download%20safety%20concept%20with%20warm%20coral%20and%20cream%20tones%2C%20shield%20and%20arrow%20icon%2C%20clean%20minimalist%20design%2C%20soft%20background%2C%20professional%20aesthetic&width=800&height=450&seq=article-cat-08&orientation=landscape',
    },
  ],
  'xinren-zhuanqu': [
    {
      id: '1',
      slug: 'caoliu-luntan-zuixin-rukou-dizhi-2026',
      title: '草榴论坛最新入口地址汇总（2026年8月更新）',
      excerpt: '本文整理了草榴论坛最新可用的入口地址与备用域名，确保您能够稳定访问论坛全部功能。',
      content: '',
      category: 'xinren-zhuanqu',
      author: '论坛管理员',
      publishDate: '2026-08-01',
      viewCount: 38542,
      commentCount: 287,
      tags: ['入口地址', '域名', '访问教程'],
      thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20digital%20interface%20with%20warm%20amber%20and%20cream%20color%20scheme%2C%20abstract%20network%20connection%20nodes%2C%20clean%20tech%20aesthetic&width=800&height=450&seq=article-cat-09&orientation=landscape',
    },
    {
      id: '2',
      slug: 'caoliu-luntan-zhuce-jiaocheng-xiangjie',
      title: '草榴论坛注册登录完整教程（2026最新版）',
      excerpt: '手把手教你完成草榴论坛的注册与登录流程，包括邮箱验证、账号设置、安全配置等详细步骤说明。',
      content: '',
      category: 'xinren-zhuanqu',
      author: '新手引导员',
      publishDate: '2026-07-28',
      viewCount: 52310,
      commentCount: 416,
      tags: ['注册教程', '登录', '账号设置'],
      thumbnail: 'https://readdy.ai/api/search-image?query=Clean%20modern%20registration%20form%20interface%20with%20warm%20cream%20background%2C%20soft%20coral%20accents%2C%20minimalist%20UI%20design%2C%20user-friendly%20onboarding%20visual&width=800&height=450&seq=article-cat-10&orientation=landscape',
    },
  ],
  'xiuxian-yule': [
    {
      id: '11',
      slug: 'caoliu-luntan-yingshi-tuijian',
      title: '草榴论坛影视推荐与讨论专区指南',
      excerpt: '发现论坛影视板块中最受欢迎的推荐帖，了解影视讨论区的参与方式与精选内容推荐。',
      content: '',
      category: 'xiuxian-yule',
      author: '影视爱好者',
      publishDate: '2026-07-03',
      viewCount: 19850,
      commentCount: 276,
      tags: ['影视推荐', '娱乐讨论', '精选内容'],
      thumbnail: 'https://readdy.ai/api/search-image?query=Film%20reel%20and%20entertainment%20concept%20with%20warm%20amber%20and%20coral%20color%20scheme%2C%20cinema%20abstract%20visualization%2C%20clean%20minimalist%20design%2C%20cream%20background&width=800&height=450&seq=article-cat-11&orientation=landscape',
    },
  ],
  'shequ-gonggao': [
    {
      id: '12',
      slug: 'caoliu-luntan-shequ-gonggao-gengxin',
      title: '草榴论坛社区公告与规则更新汇总',
      excerpt: '汇总论坛所有重要公告、规则变更与活动通知，确保会员及时了解社区最新动态。',
      content: '',
      category: 'shequ-gonggao',
      author: '论坛管理团队',
      publishDate: '2026-08-05',
      viewCount: 8920,
      commentCount: 45,
      tags: ['社区公告', '规则更新', '活动通知'],
      thumbnail: 'https://readdy.ai/api/search-image?query=Announcement%20board%20concept%20with%20warm%20secondary%20gray%20tones%2C%20notification%20bell%20abstract%2C%20clean%20minimalist%20design%2C%20cream%20background%2C%20professional%20aesthetic&width=800&height=450&seq=article-cat-12&orientation=landscape',
    },
  ],
};